// Aircraft N-number autocomplete functionality
let debounceTimer = null;
let currentController = null;

function initAircraftAutocomplete() {
    console.log('Initializing aircraft autocomplete...');
    const input = document.getElementById('aircraft_n_number');
    console.log('Found input element:', input);
    if (!input) {
        console.log('No aircraft_n_number input found on this page');
        return;
    }

    // Remove any existing event listeners by cloning the element
    const newInput = input.cloneNode(true);
    input.parentNode.replaceChild(newInput, input);

    // Create autocomplete container if it doesn't exist
    let resultsContainer = document.getElementById('aircraft_autocomplete_results');
    if (!resultsContainer) {
        resultsContainer = document.createElement('div');
        resultsContainer.id = 'aircraft_autocomplete_results';
        resultsContainer.className = 'autocomplete-results';
        resultsContainer.style.cssText = 'position: absolute; background: white; border: 1px solid #ddd; max-height: 200px; overflow-y: auto; z-index: 1000; display: none; width: 100%; box-shadow: 0 2px 4px rgba(0,0,0,0.1);';
        newInput.parentNode.style.position = 'relative';
        newInput.parentNode.appendChild(resultsContainer);
    }

    newInput.addEventListener('input', function(e) {
        const query = e.target.value.trim();

        console.log('Input event fired, query:', query);

        // Clear previous timer
        if (debounceTimer) {
            clearTimeout(debounceTimer);
        }

        // Hide results if query is too short
        if (query.length < 2) {
            resultsContainer.style.display = 'none';
            return;
        }

        // Debounce the search
        console.log('Setting up debounced search for:', query);
        debounceTimer = setTimeout(() => {
            console.log('Executing search for:', query);
            searchAircraft(query, resultsContainer, newInput);
        }, 500);
    });

    // Hide results when clicking outside
    document.addEventListener('click', function(e) {
        if (e.target !== newInput && !resultsContainer.contains(e.target)) {
            resultsContainer.style.display = 'none';
        }
    });
}

async function searchAircraft(query, resultsContainer, inputElement) {
    // Cancel previous request if any
    if (currentController) {
        currentController.abort();
    }

    currentController = new AbortController();

    try {
        // Get CSRF token
        const token = document.querySelector('meta[name="csrf-token"]')?.content;

        const url = `/master_ac_engine_results/search.json?q=${encodeURIComponent(query)}`;
        console.log('Fetching URL:', url);

        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        };

        if (token) {
            headers['X-CSRF-Token'] = token;
        }

        const response = await fetch(url, {
            method: 'GET',
            headers: headers,
            signal: currentController.signal,
            credentials: 'same-origin'
        });

        console.log('Response status:', response.status);
        console.log('Response URL:', response.url);

        if (!response.ok) {
            const text = await response.text();
            console.error('Search failed with status:', response.status, 'body:', text);
            throw new Error(`Search failed: ${response.status}`);
        }

        const results = await response.json();
        console.log('Search results:', results);
        displayResults(results, resultsContainer, inputElement);
    } catch (error) {
        if (error.name !== 'AbortError') {
            console.error('Aircraft search error:', error);
        }
    }
}

function displayResults(results, container, inputElement) {
    if (!results || results.length === 0) {
        container.innerHTML = '<div style="padding: 8px; color: #666;">No aircraft found</div>';
        container.style.display = 'block';
        return;
    }

    container.innerHTML = results.map(result => `
        <div class="autocomplete-item" data-result='${JSON.stringify(result)}' style="padding: 8px; cursor: pointer; border-bottom: 1px solid #eee;">
            <strong>${result.n_number}</strong> - ${result.aircraft_model || 'N/A'} (${result.year_mfr || 'N/A'})
        </div>
    `).join('');

    // Add click handlers
    container.querySelectorAll('.autocomplete-item').forEach(item => {
        item.addEventListener('click', function() {
            const data = JSON.parse(this.getAttribute('data-result'));
            populateAircraftFields(data, inputElement);
            container.style.display = 'none';
        });

        // Add hover effect
        item.addEventListener('mouseenter', function() {
            this.style.backgroundColor = '#f0f0f0';
        });
        item.addEventListener('mouseleave', function() {
            this.style.backgroundColor = 'white';
        });
    });

    container.style.display = 'block';
}

function populateAircraftFields(data, inputElement) {
    // Set N-number
    inputElement.value = data.n_number;

    // Populate other fields - using the actual field names from the form
    const serialField = document.getElementById('aircraft_serial_number');
    const yearField = document.getElementById('aircraft_year_mfr');
    const modelField = document.getElementById('aircraft_aircraft_model');

    if (serialField && data.serial_number) {
        serialField.value = data.serial_number;
    }
    if (yearField && data.year_mfr) {
        yearField.value = data.year_mfr;
    }
    if (modelField && data.aircraft_model) {
        modelField.value = data.aircraft_model;
    }
}

// Initialize on Turbo load events
document.addEventListener('turbo:load', initAircraftAutocomplete);
document.addEventListener('turbo:render', initAircraftAutocomplete);
// Also initialize on DOMContentLoaded for initial page load
document.addEventListener('DOMContentLoaded', initAircraftAutocomplete);
